import { render, staticRenderFns } from "./ItemNfce.vue?vue&type=template&id=1fa5e25e"
import script from "./ItemNfce.vue?vue&type=script&lang=js"
export * from "./ItemNfce.vue?vue&type=script&lang=js"
import style0 from "./ItemNfce.vue?vue&type=style&index=0&id=1fa5e25e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports